import { request } from '@src/library/API';

export const CallPostSignout = () => request({ host: 'auth', url: '/signout', method: 'post' });
